<template>
    <footer class="demo-nav-bar">
        <div class="nav-content">
            <div class="demo-progress">
                <span class="step-indicator">Step {{ current_step_number }} of {{ total_steps }}</span>
                <div class="progress-bar">
                    <div
                        class="progress-fill"
                        :style="{ width: progress_percentage + '%' }"
                    ></div>
                </div>
                <span class="step-name">{{ current_step_name }}</span>
            </div>

            <div class="nav-controls">
                <v-btn
                    text
                    small
                    :disabled="!can_go_previous"
                    @click="goToPreviousStep"
                    class="nav-btn"
                >
                    <v-icon
                        aria-hidden="true"
                        left
                        small
                    >
                        mdi-chevron-left
                    </v-icon>
                    Previous
                </v-btn>

                <v-btn
                    text
                    small
                    :disabled="!can_go_next"
                    @click="goToNextStep"
                    class="nav-btn"
                >
                    Next
                    <v-icon
                        aria-hidden="true"
                        right
                        small
                    >
                        mdi-chevron-right
                    </v-icon>
                </v-btn>

                <v-divider
                    vertical
                    class="mx-2"
                />

                <v-btn
                    text
                    small
                    @click="resetDemo"
                >
                    <v-icon
                        aria-hidden="true"
                        left
                        small
                    >
                        mdi-restart
                    </v-icon>
                    Restart Demo
                </v-btn>

                <v-divider
                    vertical
                    class="mx-2"
                />

                <v-tooltip
                    top
                    max-width="280"
                >
                    <template #activator="{ on, attrs }">
                        <v-icon
                            v-bind="attrs"
                            v-on="on"
                            size="18"
                            class="ml-2"
                            color="primary"
                        >
                            mdi-help-circle
                        </v-icon>
                    </template>
                    <span>This is just a demo — nothing is actually submitted. Click on the phone to interact as a customer, or use the navigation controls to step through by simulating behavior.</span>
                </v-tooltip>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'BottomNavigation',

    props: {
        current_step_number: {
            type: Number,
            required: true
        },

        total_steps: {
            type: Number,
            required: true
        },

        progress_percentage: {
            type: Number,
            required: true
        },

        current_step_name: {
            type: String,
            required: true
        },

        can_go_previous: {
            type: Boolean,
            default: false
        },

        can_go_next: {
            type: Boolean,
            default: false
        },
    },

    methods: {
        resetDemo() {
            this.$emit('restart');
        },

        goToPreviousStep() {
            this.$emit('previous');
        },

        goToNextStep() {
            this.$emit('next');
        }
    }
}
</script>

<style lang="scss" scoped>
.demo-nav-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 999;
    padding: 1rem 2rem;

    .nav-content {
        max-width: var(--max-width, 1400px);
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 2rem;

        @media (max-width: 768px) {
            flex-direction: column;
            gap: 1rem;
        }
    }

    .demo-progress {
        display: flex;
        align-items: center;
        gap: 1rem;
        flex: 1;

        .step-indicator {
            font-size: 0.9rem;
            font-weight: 600;
            color: var(--v-primary-base);
            min-width: 80px;
        }

        .progress-bar {
            flex: 1;
            height: 6px;
            background: #e0e0e0;
            border-radius: 3px;
            overflow: hidden;
            max-width: 200px;

            .progress-fill {
                height: 100%;
                background: var(--v-primary-base);
                transition: width 0.3s ease;
            }
        }

        .step-name {
            font-size: 0.9rem;
            color: #666;
            min-width: 140px;
        }

        @media (max-width: 768px) {
            width: 100%;

            .step-indicator,
            .step-name {
                min-width: auto;
            }

            .progress-bar {
                max-width: none;
            }
        }
    }

    .nav-controls {
        display: flex;
        align-items: center;
        gap: 0.25rem;

        .nav-btn {
            min-width: 80px;
        }

        @media (max-width: 768px) {
            gap: 0.5rem;
            
            .nav-btn {
                min-width: 70px;
                font-size: 0.8rem;
            }
        }
    }
}
</style>